import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';
import {
  readResponsePagination,
  resolveListPagination,
} from '../../shared/utils/list-pagination.util';
import {
  MembershipPauseEvent,
  MembershipPauseEventListParams,
  MembershipPauseEventListResult,
} from '../models/membership-pause-event.model';

/** Super-admin read of one company's membership pause history (CWS-1648). */
@Injectable({ providedIn: 'root' })
export class MembershipPauseEventsService {
  constructor(private apiService: ApiService) {}

  listEvents(
    companyId: string,
    params: MembershipPauseEventListParams = {}
  ): Observable<ApiResponse<MembershipPauseEventListResult>> {
    const page = params.page ?? 1;
    const limit = params.limit ?? 25;

    const queryParams: Record<string, string> = {};
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams[key] = String(value);
      }
    });

    return this.apiService
      .getWithSuperAdminToken<MembershipPauseEvent[]>(
        `admin/super-admin/companies/${encodeURIComponent(companyId)}/membership-pause-events`,
        queryParams
      )
      .pipe(
        map(res => {
          const events = Array.isArray(res.data) ? res.data : [];
          const pagination = resolveListPagination(
            readResponsePagination(res),
            { page, limit },
            events.length
          );
          return { ...res, data: { events, ...pagination } };
        })
      );
  }
}
